export default function generateUserOptions(users = []) {
  return users.map((user) => ({
    value: user._id,
    label: user.full_name,
  }));
}
